module.exports = __webpack_public_path__ + "static/media/hp-dream@2x.8e23122b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gear/display/hp-dream@2x.png
// module id = 323
// module chunks = 0